import { Button } from "./Button";

interface Props {
  open: boolean;
  onClose: () => void;
  studentName?: string;
  studentYear?: string;
}

export function ConsentModal({ open, onClose, studentName }: Props) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50"
      onClick={onClose}
    >
      <div
        className="bg-white max-w-2xl max-h-[85vh] overflow-y-auto p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          className="text-2xl mb-4"
          style={{ fontFamily: "var(--font-serif)" }}
        >
          Согласие на обработку персональных данных
        </h2>
        <div className="text-sm leading-relaxed space-y-3 text-[var(--color-ink)]">
          <p>
            Я подтверждаю, что являюсь законным представителем
            (родителем/опекуном) ребёнка{" "}
            <strong>
              {studentName || "(ФИО ребёнка будет показано после ввода кода)"}
            </strong>
            , и даю согласие на обработку его персональных данных МАОУ
            «Гимназия №94» г. Екатеринбурга и обработчиком ООО «Таймвеб Клауд»
            (ИНН 7842399670) в целях ведения портфолио ребёнка в системе
            «Гордость 94».
          </p>

          <h3 className="font-bold pt-2">Объём ПДн ребёнка:</h3>
          <p>
            фамилия, имя, отчество, класс, год обучения, фото и видео
            достижений (загружаемые мной), описания достижений.
          </p>

          <h3 className="font-bold pt-2">Объём ПДн родителя:</h3>
          <p>ФИО, email, телефон (опц.), IP-адрес при входе.</p>

          <h3 className="font-bold pt-2">Третьи лица:</h3>
          <p>
            ООО «Таймвеб Клауд» (хранение медиа-файлов в зашифрованном
            хранилище в РФ, договор оператора ПДн).
          </p>

          <h3 className="font-bold pt-2">Срок обработки:</h3>
          <p>
            до окончания обучения ребёнка + 3 года после выпуска, либо до
            отзыва согласия (через кнопку «Удалить аккаунт» в кабинете).
          </p>

          <h3 className="font-bold pt-2">Право на отзыв:</h3>
          <p>в любой момент через кнопку «Удалить аккаунт» в /cabinet/profile.</p>

          <p className="pt-3 text-[var(--color-muted)] italic">
            Я подтверждаю, что не нарушаю прав третьих лиц при загрузке
            фото/видео (не публикую изображения других детей без согласия их
            родителей).
          </p>
        </div>
        <div className="mt-6 flex justify-end">
          <Button variant="primary" onClick={onClose}>
            Закрыть
          </Button>
        </div>
      </div>
    </div>
  );
}
